import React, { Component } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { browserName, browserVersion } from 'react-device-detect';
import { Table, Input, Form, FormGroup, Label, Button } from 'reactstrap';
import { connect } from 'react-redux';

class RevokeAccess extends Component {
    static displayName = RevokeAccess.name;

    constructor(props) {
        super(props);
        this.state = {
            returnable: [],
            browser: `${browserName}${browserVersion}`,
            ip: "",
            permissionFlag: true,
            revokedList: [],
            optionList: [],
            revokeReasonList: [],
            nameOption: "DEFAULT",
            accessOption: "DEFAULT",
            reason: "DEFAULT",
            expOption: "1955-11-05"
        }
        this.getUserInfo();
        this.testPermission();
        this.getRevoked();
        this.getOptions();
    }

    async getData() {
        const response = await fetch('https://api.ipify.org?format=json', { dataType: 'jsonp' });
        const data = await response.json();
        this.setState({
            ip: data.ip
        })
        this.getUserInfo();
    }

    async getUserInfo() {
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        //let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        //const response = await fetch('user', { method: 'GET', headers: { 'Authorization': bearerVAR } });
        //const data = await response.json();
        //localStorage.setItem("lastFetch", moment());
        //this.props.updateFetchTime();
        let today = new Date().toISOString().slice(0, 10)
        this.setState({
            //returnable: this.props.reduxData.userInfo,
            expOption: today
        });

    }

    //async recordComingHere() {
    //    let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
    //    let toSend = {
    //        pagePK: "2042",//1043 in prod
    //        department: this.props.reduxData.userInfo.level.pk,
    //        userPCID: this.props.reduxData.userInfo.pcid,
    //        ip: this.state.ip,
    //        browser: this.state.browser,
    //        userID: this.props.reduxData.userInfo.username
    //    }
    //    const response = await fetch('logging', {
    //        method: 'POST',
    //        headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
    //        body: JSON.stringify(toSend)
    //    });
    //    const data = await response.json();
    //    localStorage.setItem("lastFetch", moment());
    //}

    async testPermission() {
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        let toSend = {
            userLevel: this.props.reduxData.userInfo.level.pk,
            pagepk: "/RevokeAccess"//1043 in prod
        }
        const response = await fetch('ValidDepartments', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        })
        const data = await response.json();
        //localStorage.setItem("lastFetch", moment());
        this.props.updateFetchTime();
        this.setState({
            permissionFlag: data
        })
    }

    async getRevoked() {
        //localStorage.setItem("lastFetch", moment());
        this.props.updateFetchTime();
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        let toSend = {
            userLevel: this.props.reduxData.userInfo.level.pk
        }
        const response = await fetch('GetRevokedAccess', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        })
        const data = await response.json();
        this.setState({
            revokedList: data
        })
    }

    async getOptions() {
        //localStorage.setItem("lastFetch", moment());
        this.props.updateFetchTime();
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        let toSend = {
            userLevel: this.props.reduxData.userInfo.level.pk
        }
        const response = await fetch('RevokeAllOptions', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        })
        const data = await response.json();
        this.setState({
            optionList: data
        })
        this.getRevokedReasons();
    }

    async getRevokedReasons() {
        //localStorage.setItem("lastFetch", moment());
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        this.props.updateFetchTime();
        let toSend = {
            userLevel: this.props.reduxData.userInfo.level.pk
        }
        const response = await fetch('GetRevokeReasons', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        })
        const data = await response.json();
        this.setState({
            revokeReasonList: data
        })
    }

    componentDidMount() {

    }

    async newRevoke(e) {
        e.preventDefault();
        //console.log("new revoke");
        const dataInput = new FormData(e.target);
        //localStorage.setItem("lastFetch", moment());
        this.props.updateFetchTime();
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        let toSend = {
            userLevel: this.props.reduxData.userInfo.level.pk,
            pcid: dataInput.get("name"),
            access: dataInput.get("access"),
            reason: dataInput.get("reason"),
            expdate: dataInput.get("expdate")
        }
        const response = await fetch('AddRevoke', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        })
        const data = await response.json();
        this.getRevoked();
    }

    async changeExpDate(e, PK) {
        //console.log("change date: " + e + ", " + PK)
        //localStorage.setItem("lastFetch", moment());
        this.props.updateFetchTime();
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        let toSend = {
            userLevel: this.props.reduxData.userInfo.level.pk,
            newdate: e,
            pk: PK
        }
        const response = await fetch('ChangeRevokeDate', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        })
        const data = await response.json();
        this.getRevoked();
    }

    render() {
        if (this.state.permissionFlag == false) {
            this.props.passNewPage(-1);
        }
        return (<div>
            <Form className='d-flex' onSubmit={(e) => this.newRevoke(e)}>
                <FormGroup className="mb-2 mr-sm-2 mb-sm-0">
                    <Label>User</Label>
                    <Input type="select" id="name" name="name" value={this.state.nameOption} onChange={(e) => this.setState({ nameOption: e.target.value, accessOption:"DEFAULT" }) }>
                        <option value="DEFAULT" disabled>Select</option>
                        {[...new Set(this.state.optionList.map(user => user.pcid))].map(item => (
                            <option value={item}>{this.state.optionList.find((element) => element.pcid == item).name }</option>
                        )) }
                    </Input>
                </FormGroup>
                {this.state.nameOption != "DEFAULT" && <FormGroup>
                    <Label>Access</Label>
                    <Input type="select" id="access" name="access" value={this.state.accessOption} onChange={(e) => this.setState({accessOption: e.target.value}) }>
                        <option value="DEFAULT" disabled>Select</option>
                        {this.state.optionList.filter((option) => option.pcid == this.state.nameOption).map(item => (
                            <option value={item.access}>{item.access}</option>
                        )) }
                    </Input>
                </FormGroup>}
                {this.state.accessOption != "DEFAULT" && <FormGroup>
                    <Label>Reason</Label>
                    <Input type="select" id="reason" name="reason" value={this.state.reason} onChange={(e) => this.setState({ reason: e.target.value })}>
                        <option value="DEFAULT" disabled>Select</option>
                        {this.state.revokeReasonList.map(item => (
                            <option value={item.reason}>{item.reason}</option>
                        ))}
                        {/*<option value="Student Conduct">Student Conduct</option>*/}
                        {/*<option value="Emergency Access by DOS">Emergency Access by DOS</option>*/}
                    </Input>
                </FormGroup>}
                {this.state.accessOption != "DEFAULT" && <FormGroup>
                    <Label>Expiration Date</Label>
                    <Input type="date" name="expdate" id="expdate" value={this.state.expOption} onChange={(e) => this.setState({expOption: e.target.value}) } />
                </FormGroup>}
                {this.state.accessOption != "DEFAULT" && this.state.reason != "DEFAULT" && <Button type="submit" outline color="success">Submit</Button>}
            </Form><br />
            <Table>
                <thead>
                    <tr>
                        <th>PCID</th>
                        <th>Name</th>
                        <th>Revoked Access</th>
                        <th>Revoked By</th>
                        <th>Revoked For</th>
                        <th>Expiration Date</th>
                    </tr>
                </thead>
                <tbody>
                    {this.state.revokedList.map(item => (
                        <tr>
                            <td>{item.pcid}</td>
                            <td>{item.firstname} {item.lastname}</td>
                            <td>{item.access}</td>
                            <td>{item.revoker}</td>
                            <td>{item.reason}</td>
                            <td><Input type="date" defaultValue={item.exdate} name="exdate" id="exdate" onChange={(e) => this.changeExpDate(e.target.value, item.pk)} /></td>
                            {/*<td>{item.exdate}</td>*/}
                        </tr>
                    ))}
                </tbody>
            </Table>
        </div>);
    }
}

const mapStateTo = state => ({
    reduxData: state
})

const mapDispatchTo = (dispatch) => {
    return {
        updateFetchTime: () => dispatch({ type: 'foundation/setFetchTime' })
    }
}

export default connect(mapStateTo, mapDispatchTo)(RevokeAccess);